import React from "react";
import { FaArrowRight, FaArrowLeft, FaPlus } from "react-icons/fa";
import { BsThreeDotsVertical } from "react-icons/bs";
import { GiCheckMark } from "react-icons/gi";
import pubHeroBuilding from "../../assets/pub-hero-building.png";
import storeyNight from "../../assets/storey_night.png";
import floorPlanModal from "../../assets/floor-plan-modal.svg";
import smartLogo from "../../assets/smart.png";
import verifiedBadge from "../../assets/verified.png";

const qualities = [
    {
        title: "Verified & Tamper-Proof",
        description: "Every project record is C2PA signed and tamper-proof.",
    },
    {
        title: "Lasting Proof of Experience",
        description: "Build a permanent portfolio that grows with every project.",
    },
    {
        title: "Share Anywhere",
        description: "Share securely with clients, partners, investors and regulators.",
    },
    {
        title: "Always Up to Date",
        description: "Live updates that keep your portfolio accurate and relevant.",
    },
];

const PubShowcase = () => (
    <section className="pub-showcase">
        <div className="pub-showcase-inner">
            {/* ── LEFT PANEL ── */}
            <div className="pub-showcase-left">
                <span className="pub-showcase-tag">DIGITAL PORTFOLIO</span>
                {/* <h2 className="pub-showcase-heading">
                    Showcase. Verify.{" "}
                    <span>Win More Work.</span>
                </h2> */}
                <p className="pub-showcase-sub">
                    Move beyond static company profiles. ConRa creates a verified digital portfolio for your projects-automatically secured with C2PA standards so your track record is always credible and shareable.
                </p>
                <ul className="pub-showcase-features">
                    {qualities.map((feature, i) => (
                        <li key={i}>
                            <GiCheckMark className="pub-showcase-check" />
                            <div className="pub-showcase-feature-text">
                                <p className="pub-showcase-feature-title">{feature.title}</p>
                                <p className="pub-showcase-feature-description">{feature.description}</p>
                            </div>
                        </li>
                    ))}
                </ul>
                <button
                    className="filled-button"
                    onClick={() => window.open("https://web.conra.net", "_blank")}
                >
                    Explore Portfolio <FaArrowRight style={{ marginLeft: 6 }} />
                </button>
            </div>

            {/* ── RIGHT PANEL ── */}
            <div className="pub-showcase-right">

                {/* Featured Project Card */}
                <div className="psc-featured-card">
                    <div className="psc-featured-img-wrap">
                        <img src={pubHeroBuilding} alt="Residential Construction: The Meadows" className="psc-featured-img" />
                        <span className="psc-featured-banner">FEATURED PROJECT</span>
                    </div>
                    <div className="psc-featured-body">
                        <div className="psc-featured-title-row">
                            <h3 className="psc-featured-title">Residential Construction: The Meadows</h3>
                            <span className="psc-featured-flag">🇺🇸</span>
                        </div>
                        <p className="psc-featured-desc">
                            This project involves the construction of a modern residential maisonette development designed for long-term living and functional family spaces. The scope includes structural works, architectural finishes, and integrated building services to deliver durable and efficient...
                        </p>
                        <div className="psc-featured-footer">
                            <div className="psc-company-row">
                                <img src={smartLogo} alt="SmartConstructs" className="psc-company-logo" />
                                <span className="psc-company-name">SmartConstructs</span>
                                <img src={verifiedBadge} alt="verified" className="psc-verified-badge" />
                            </div>
                            <span className="psc-project-id">FXZ21-KEN</span>
                        </div>
                    </div>
                </div>

                {/* Bottom pair */}
                <div className="psc-bottom-pair">
                    <img src={storeyNight} alt="Construction site" className="psc-house-img" />

                    {/* Floor Plan Card */}
                    <div className="psc-floor-card">
                        <div className="psc-floor-card-header">
                            <div className="psc-floor-card-title-row">
                                <FaArrowLeft className="psc-floor-back" />
                                <span className="psc-floor-title">Residential Construction: The Meadows</span>
                            </div>
                            <BsThreeDotsVertical className="psc-floor-dots" />
                        </div>
                        <div className="psc-floor-section">
                            <span className="psc-floor-section-label">Floor Plan Layout</span>
                            <FaPlus className="psc-floor-plus" />
                        </div>
                        <div className="psc-floor-plans">
                            <div className="psc-floor-plan-item">
                                <img src={floorPlanModal} alt="Ground Floor Plan" className="psc-floor-plan-img" />
                                <span className="psc-floor-plan-label">Ground Floor • 3 Plans</span>
                            </div>
                            <div className="psc-floor-plan-item">
                                <img src={floorPlanModal} alt="1st Floor Plan" className="psc-floor-plan-img" />
                                <span className="psc-floor-plan-label">1st Floor • 2 Plans</span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
);

export default PubShowcase;
